import React, { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { SocialLink } from '..'
import { Button } from '../../../atoms/button'
import { convertToRem } from '../../../../utils/style'

interface SocialLinksProps {
  links: SocialLink[]
  className?: string
}

const SocialLinks: FunctionComponent<SocialLinksProps> = ({ links, className }) => {
  return (
    <SocialLinksWrapper className={className}>
      {links.map((link, index) => {
        return (
          <li key={`social-link-${link.icon}-${index}`}>
            <Link
              themeOverride="background_is_lighter_secondary"
              variant="outlined"
              as="a"
              href={link.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={link.icon.url} alt={link.icon.alternativeText ?? ''} />
            </Link>
          </li>
        )
      })}
    </SocialLinksWrapper>
  )
}

const SocialLinksWrapper = styled.ul`
  display: flex;
  list-style: none;
  gap: var(--gap-m);
  img {
    height: 1.25rem;
  }

  @media (max-width: 1279px) {
    justify-content: space-between;
  }
`
const Link = styled(Button)`
  padding: ${convertToRem(20)};
  width: ${convertToRem(62)} !important;
`

export default SocialLinks
export { Link as SocialLink }
